/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["nz-layout[_ngcontent-%COMP%]{min-height:100vh;text-align:center}nz-card[_ngcontent-%COMP%]{position:absolute;transform:translate(-50%,-50%);top:49%;left:50%;width:400px}.card-cover[_ngcontent-%COMP%]{padding-top:20px}.card-message[_ngcontent-%COMP%]{display:inline-block;font-weight:500;font-size:26px;margin-top:0;margin-bottom:2px}button[_ngcontent-%COMP%]{margin-top:10px}[_nghost-%COMP%]     .ant-card-body{padding-top:16px}"];
export { styles as styles };
